<script>
    import MainContainer from '@/components/container/MainContainer.vue';
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';

    import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import AssetTypeList from '@/components/page-filter-edit/AssetTypeList.vue';
    import FilterAdd from '@/components/page-filter-edit/filter-add/FilterAdd.vue';
    import FilterEdit from '@/components/page-filter-edit/filter-edit/FilterEdit.vue';
    import FilterItemAdd from '@/components/page-filter-edit/filter-item-add/FilterItemAdd.vue';
    import FilterItemEdit from '@/components/page-filter-edit/filter-item-edit/FilterItemEdit.vue';

    import { calculatePromise, promiseAll } from '@/api/default.js';

    export default {
        components: {
            MainContainer: MainContainer,
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,

            ButtonAnyNew: ButtonAnyNew,
            ButtonReturn: ButtonReturn,

            AssetTypeList: AssetTypeList,
            FilterAdd: FilterAdd,
            FilterEdit: FilterEdit,
            FilterItemAdd: FilterItemAdd,
            FilterItemEdit: FilterItemEdit,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            await this.$store.dispatch('CHECK_ASSET_TYPES');
            const promiseList = await calculatePromise([
                {dispatch: 'CHECK_FILTERS_AXIOS', commit: 'FILTERS_ADD', isArray: true},
            ]);
            await promiseAll(promiseList);
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            async toggleNewFilter() {
                this.$store.commit('IS_SHOW_FILTER_ADD', 
                    !this.$store.getters.IS_SHOW_FILTER_ADD
                );
                this.$store.dispatch('CHECK_FILTER_ADD');
            },
            async toggleNewFilterItem() {
                this.$store.commit('IS_SHOW_FILTER_ITEM_ADD',
                    !this.$store.getters.IS_SHOW_FILTER_ITEM_ADD
                );
                this.$store.dispatch('CHECK_FILTER_ITEM_ADD');
            }
        }

    }
</script>


<template>
    <FilterAdd />
    <FilterEdit />
    <FilterItemAdd />
    <FilterItemEdit />

    <MainContainer>
        <LeftPanel>
            <ButtonAnyNew
                title="New Filter"
                :method="toggleNewFilter"
            />
            <ButtonAnyNew
                title="New Filter Item"
                :method="toggleNewFilterItem"
            />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <AssetTypeList />
        </RightContainer>
    </MainContainer>
</template>